/* @typescript-eslint/ban-ts-ignore */

import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

interface State {
  company: Company;
  portfolioId: string;
  inviteId?: string;
  claimCode?: string;
  customer?: Customer;
}

const initialState: Partial<State> = {
  step: 'information',

  //@ts-ignore
  company: {},
};

const slice = createSlice({
  name: 'signUp',
  initialState: initialState as State,
  reducers: {
    initCompanyInformation: (state: State, action: PayloadAction<Partial<Company>>): State => {
      state.company = { ...state.company, ...action.payload };
      return state;
    },
    changeInviteInformation: (state: State, action: PayloadAction<{ inviteId?: string; claimCode?: string }>): State => {
      state.inviteId = action.payload.inviteId;
      state.claimCode = action.payload.claimCode;
      return state;
    },
    changeCompanyInformation: (state: State, action: PayloadAction<Partial<Company>>): State => {
      state.company = { ...state.company, ...action.payload };

      return state;
    },

    changeCustomer: (state: State, action: PayloadAction<Customer>): State => {
      state.customer = action.payload;
      return state;
    },
  },
});

const { changeCompanyInformation, initCompanyInformation, changeInviteInformation, changeCustomer } = slice.actions;
export { changeCompanyInformation, initCompanyInformation, changeInviteInformation, changeCustomer };

export default slice.reducer;

export const selectGuestCountry = createSelector(
  (state: RootState) => state.signUp.company,
  company => company?.country,
);
